import { binarize } from './binarize';
import { brightness } from './brightness';
import { gamma } from './gamma';
import { gaussianBlur } from './gaussian-blur';
import { grayScale } from './grayscale';
import { sharpen } from './sharpen';
import { solarize } from './solarize';

export const filters = {
  binarize,
  brightness,
  gamma,
  gaussianBlur,
  grayScale,
  sharpen,
  solarize,
};
